<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status data menjadi <b class="font-weight-bold black--text">di{{ message.status }}</b> ?

                <div v-if="message.status === 'tolak'">
                  <ValidationObserver 
                    ref="form">
                    <v-form>

                      <div
                        class="mb-6 mt-5">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="rejected_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      
                    </v-form>
                  </ValidationObserver>
                </div>
  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <div class="color-dark-blue fs-22 font-weight-bold mb-6">
            Detail Pembelian
          </div>

          <v-row>
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                  
                  <div>
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Nama Supplier
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.supplier_name }}
                    </div>
                  </div>

                  <div class="mt-4">
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Kategori
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.category }}
                    </div>
                  </div>

                  <div class="mt-4" v-if="detail.status === 'terbit'">
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Nomor PO
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.number }}
                    </div>
                  </div>

                  <div class="mt-4">
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Nomor Permintaan
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.permintaan_number }}
                    </div>
                  </div>

                  <div class="mt-4">
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Tanggal Jatuh Tempo
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.due_date | date }}
                    </div>
                  </div>

                  <div class="mt-4">
                    <div 
                      class="fs-14">å
                      <!-- <span class="red--text">*</span> -->
                      Catatan
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.note }}
                    </div>
                  </div>
                  

                  <div>
                    <div>
                      Status Approval
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.status === 'proses' ? 'Proses' : detail.status === 'approved' ? 'Diterima' : detail.status === 'draft' ? 'Disimpan Draft' : detail.status === 'terbit' ? 'Diterbitkan' : 'Ditolak'}}
                    </div>
                  </div>
                  <!-- <div class="" v-if="detail.status === 'rejected'">
                    <div>
                      Alasan
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.rejected_reason }}
                    </div>
                  </div> -->

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <div v-if="Object.keys(detail).length > 0">
            <Proses :detail="detail" @update="fetchDetail()" />
          </div>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        rejected_reason: '',
        tabs: 0,
        tab: [
          {
            title: 'Detail',

            link: `/customer/data/detail/${this.$route.params.id}?menu=detail`
          },
          {
            title: 'Toko',
            link: `/customer/data/detail/${this.$route.params.id}?menu=toko`
          },
          // {
          //   title: 'Jadwal Visit',
          //   link: `/customer/data/detail/${this.$route.params.id}?menu=visit`
          // },
          {
            title: 'Approval',
            link: `/customer/data/detail/${this.$route.params.id}?menu=approval`
          }
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false
        },

        detail: {},

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          load: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      Proses: () => import(/* webpackPrefetch: true */ '@/components/pembelian/proses.vue'),
      Approval: () => import(/* webpackPrefetch: true */ '@/components/customer/approval.vue'),
      Toko: () => import(/* webpackPrefetch: true */ '@/components/customer/toko.vue'),
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    watch: {
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.detail = {}
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/pembelian/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
            // this.detail.mobilephone_arr = this.detail.mobilephone_arr.length > 0 ? JSON.parse(this.detail.mobilephone_arr) : []
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''
        const isValid = this.message.status === 'terima' ? true : await this.$refs.form.validate()
        if (isValid) {
          

        this.process.form = true

        await post(`admin/pembelian/approval`, {
          data: {
            id: this.detail.id,
            status: this.message.status === 'terima' ? 'approved' : 'rejected'
            // rejected_reason: this.rejected_reason
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>